module.exports = __webpack_public_path__ + "static/media/register-bg.2ccde6b9.jpg";